module.exports = "https://cdn.realtymogul.com/static/media/icon_chart.0f7a1c3f.svg";